import ErrorDashboard from 'components/error/ErrorDashboard';
import styled, { css } from 'styled-components';
import { Outlet } from 'react-router-dom';
import useErrorPage from 'hooks/error/useErrorPage';
import ErrorNoti from 'components/common/ErrorNoti';
import Loading from 'components/common/Loading';

const ErrorPage = () => {
  const { error, loading } = useErrorPage();

  return (
    <>
      {loading.length !== 0 ? <Loading /> : error && <ErrorNoti />}
      <ErrorPageBlock loading={loading.length} error={error}>
        <div className="title">장애 이력</div>
        <ErrorDashboard />
        <Outlet />
      </ErrorPageBlock>
    </>
  );
};

export default ErrorPage;

const ErrorPageBlock = styled.div`
  width: 1000px;
  margin: 0 auto;

  .title {
    margin-top: 1rem;
    font-size: 1.2rem;
    font-weight: bold;
  }

  .box {
    margin-top: 1rem;
    padding: 0 30px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);
  }

  .font-l {
    font-size: 1.3rem;
  }

  ${props =>
    (props.loading !== 0 || props.error) &&
    css`
      display: none;
    `}
`;
